// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".secondary-light-text {\n  color: var(--v-primary-lighten3);\n}\n.indicator {\n  width: 8px;\n  height: 8px;\n}\n.indicator.red-indicator {\n  background-color: var(--v-red-base);\n}\n.indicator.green-indicator {\n  background-color: var(--v-green-base);\n}\n.indicator.orange-indicator {\n  background-color: var(--v-orange-base);\n}", ""]);
// Exports
module.exports = exports;
